export default __webpack_public_path__ + "static/media/BlockchainIllustration.33920dfb.svg";